module.exports = __webpack_public_path__ + "img/candidates.276488b3.svg";